import type { SVGProps } from 'react';

const SvgSubtitles = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 5H6C4.35 5 3 6.35 3 8v8c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3V8c0-1.65-1.35-3-3-3m1 11c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h12c.55 0 1 .45 1 1z"
    />
    <path
      fill="currentcolor"
      d="M10 11c.55 0 1-.45 1-1s-.45-1-1-1H9c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1c.55 0 1-.45 1-1s-.45-1-1-1H9v-2zm6 0c.55 0 1-.45 1-1s-.45-1-1-1h-1c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1c.55 0 1-.45 1-1s-.45-1-1-1h-1v-2z"
    />
  </svg>
);
export default SvgSubtitles;
